
export default {
  data() {
    return {
      touchStartPosition: 0,
      touchEndPosition: 0,
      pixelsMoved: 0,
      previousTouchPosition: 0,
      currentTouchPosition: 0
    }
  },
  methods: {
    trackSwipe(element, axis, next, prev) {

      const listenOnSwipe = (e, axis) => {
        if(!['y','x'].includes(axis))
          return;

        if(axis === 'y') axis = 'clientY';
        if(axis === 'x') axis = 'clientX';

        const touchPoint = Object.keys(e.touches).reduce((total, key)=> {
          total = e.touches[key][axis];
          return total;
        }, 0);

        this.previousTouchPosition = this.currentTouchPosition;
        this.currentTouchPosition = touchPoint / e.touches.length;

        if(this.touchStartPosition != 0 || this.previousTouchPosition != 0)
          this.touchStartPosition = this.previousTouchPosition;

        this.touchEndPosition = this.currentTouchPosition;

        this.pixelsMoved = this.previousTouchPosition - this.currentTouchPosition;
      }

      const calculateDirection = (axis) => {
        if(!['y','x'].includes(axis))
          return;

        let directions;
        if(axis === 'y') directions = { a: 'up', b: 'down' };
        if(axis === 'x') directions = { a: 'left', b: 'right' };

        if(Math.abs(this.touchStartPosition - this.touchEndPosition) <= 10)
          return;

        this.touchEndPosition = 0;
        this.touchStartPosition = 0;

        if(this.pixelsMoved >= 0) {
          return directions.a;
        } else {
          return directions.b;
        }
      }

      const onTouchMove = (e) => listenOnSwipe(e, axis);

      const onTouchEnd = () => {
        const direction = calculateDirection(axis);

        if(axis === 'x') {
          if(direction === 'left') next();
          if(direction === 'right') prev();
        }

        if(axis === 'y') {
          if(direction === 'up') next();
          if(direction === 'down') prev();
        }
      }

      element.addEventListener('touchmove', onTouchMove);
      element.addEventListener('touchend', onTouchEnd);
    }
  }
}



// WEBPACK FOOTER //
// ./components/mixins/Swipe.vue